import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as authActions from '../../auth/actions';
import ClasstingAppBar from '../components/ClasstingAppBar';

const AppBarContainer = (props) => {
  const info = useSelector(state => state.user.info);

  const dispatch = useDispatch();

  const signOut = useCallback((...args) => dispatch(authActions.signOutRequest(...args)), [dispatch]);

  return <ClasstingAppBar info={info} onSignOut={signOut} {...props} />;
};

export default AppBarContainer;
